


























import { Component, Prop, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import SidebarItem from "./SidebarItem.vue";
import variables from "@/styles/_variables.scss";
import SidebarLogo from "./SidebarLogo.vue";
import { PermissionModule } from "@/store/modules/permission";
import { SettingsModule } from "@/store/modules/settings";
import Layout from "@/layout/index.vue";
@Component({
  name: "SideBar",
  components: {
    SidebarItem,
    SidebarLogo,
  },
})
export default class extends Vue {
  created() {
    this.routess();
  }
  // monuted() {
  //   this.routess();
  // }
  private routersa: any = [];
  private royterpath = "";
  private routess() {
    let examineeManage = {
      path: "/examineeManage",
      redirect: "noredirect",
      name: "examineeManage",
      component: Layout,
      children: [
        {
          path: "examineeManage",
          component: () => import("@/views/examineeManage/index.vue"),
          name: "examineeManage",
          meta: {
            title: "用户管理",
            icon: "examinee",
            requireAuth: true,
          },
        },
      ],
    };
    let guideManage = {
      path: "/guideManage",
      redirect: "noredirect",
      name: "guideManage",
      component: Layout,
      children: [
        {
          path: "guideManage",
          component: () => import("@/views/guideManage/index.vue"),
          name: "Apparatus",
          meta: {
            title: "指南管理",
            icon: "equiptype",
            requireAuth: true,
          },
        },
      ],
    };
    let tissuemanage = {
      path: "/tissuemanage",
      redirect: "noredirect",
      name: "tissuemanage",
      component: Layout,
      children: [
        {
          path: "tissuemanage",
          component: () => import("@/views/tissuemanage/index.vue"),
          name: "tissuemanage",
          meta: {
            title: "课题管理",
            icon: "tissue",
            requireAuth: true,
          },
        },
      ],
    };
    let expertLine = {
      path: "/expertLine",
      redirect: "noredirect",
      name: "expertLine",
      component: Layout,
      children: [
        {
          path: "expertLine",
          component: () => import("@/views/expertLine/index.vue"),
          name: "expertLine",
          meta: {
            title: "课题管理",
            icon: "tissue",
            requireAuth: true,
          },
        },
      ],
    };
    let expertTank = {
      path: "/expertTank",
      redirect: "noredirect",
      name: "expertTank",
      component: Layout,
      children: [
        {
          path: "expertTank",
          component: () => import("@/views/expertTank/index.vue"),
          name: "expertTank",
          meta: {
            title: "专家库",
            icon: "tissue",
            requireAuth: true,
          },
        },
      ]
    }
    let expertManage = {
      path: "/expertManage",
      redirect: "noredirect",
      name: "expertManage",
      component: Layout,
      children: [
        {
          path: "expertManage",
          component: () => import("@/views/expertManage/index.vue"),
          name: "expertManage",
          meta: {
            title: "课题管理",
            icon: "tissue",
            requireAuth: true
          }
        }
      ]
    }
    let parm:any = sessionStorage.getItem('role')
    let userId = sessionStorage.getItem('id')
    if (parm === '0') {
      // 临时添加 写死内容  andy   2022-04-11
      if(userId === 'b2fd7b257fcfcadbc9bcbf591ed8eab2'){
        this.routersa.push(tissuemanage)
      }else{
        this.routersa.push(tissuemanage, guideManage, examineeManage, expertTank)
      }
    } else if (parm === '3') {
      this.routersa.push(expertManage)
    }
    // showpower.length=0是游客身份 1超级管理员 2学校管理员 3集团军管理员 4合成旅管理员
  }
  get sidebar() {
    return AppModule.sidebar
  }
  get showLogo() {
    return SettingsModule.showSidebarLogo
  }
  get routes() {
    PermissionModule.routes.forEach((res: any) => {})

    return PermissionModule.routes
  }

  get variables() {
    return variables;
  }
  get activeMenu() {
    const route = this.$route;
    const { meta, path } = route;
    // if set path, the sidebar will highlight the path you set
    if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  }
  get isCollapse() {
    return !this.sidebar.opened;
  }
}
